
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * MarginRateProfileStatus enum
 */
class MarginRateProfileStatus {
  /**
   * Initialize enum with a given value
   * @param {MarginRateProfileStatus|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof MarginRateProfileStatus) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!MarginRateProfileStatus}
   * @param {!MarginRateProfileStatus} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof MarginRateProfileStatus)) {
      throw new TypeError('Instance of MarginRateProfileStatus is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!MarginRateProfileStatus}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!MarginRateProfileStatus}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === MarginRateProfileStatus.INACTIVE.value) {
      return 'INACTIVE'
    }
    if (this.value === MarginRateProfileStatus.ACTIVE.value) {
      return 'ACTIVE'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!MarginRateProfileStatus}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!MarginRateProfileStatus}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!MarginRateProfileStatus} Created enum
   */
  static fromObject (other) {
    return new MarginRateProfileStatus(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
MarginRateProfileStatus.INACTIVE = new MarginRateProfileStatus(0 + 0)
// noinspection PointlessArithmeticExpressionJS
MarginRateProfileStatus.ACTIVE = new MarginRateProfileStatus(0 + 1)

export { MarginRateProfileStatus };

/**
 * Fast Binary Encoding MarginRateProfileStatus field model
 */
class FieldModelMarginRateProfileStatus extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelMarginRateProfileStatus}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the value
   * @this {!FieldModelMarginRateProfileStatus}
   * @param {MarginRateProfileStatus=} defaults Default value, defaults is new MarginRateProfileStatus()
   * @returns {!MarginRateProfileStatus} Result value
   */
  get (defaults = new MarginRateProfileStatus()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new MarginRateProfileStatus(this.readInt32(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelMarginRateProfileStatus}
   * @param {!MarginRateProfileStatus} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeInt32(this.fbeOffset, value.value)
  }
}

export { FieldModelMarginRateProfileStatus };
